export default {
  metrics: {
    nrr: {
      title: 'NRR % (Trimestrale)',
      description:
        '(Entrate abbonamenti {{currentMonth}} (T{{currentQuarter}}) + Entrate commissioni {{currentMonth}} (T{{currentQuarter}})) / (Entrate abbonamenti {{prevMonth}} (fine T{{prevQuarter}}) + Entrate commissioni {{prevMonth}} (fine T{{prevQuarter}})) * 100',
    },
    upgrades: 'Upgrade account',
    downgrades: 'Downgrade account',
    gte_c_tier: 'Account ≥ Grado C',
    churn: 'Abbandoni (sospesi)',
    offers_turned_on: 'Offerte attivate',
    flyers_sent: 'Volantini inviati',
    on_google_ads_trial: 'In prova Google Ads',
    converted_google_ads: 'Google Ads convertiti con successo',
    first_time_500_monthly_sales: 'Primo mese da €500',
    '14_days_no_sales': '14 giorni attivi, nessun ricavo',
  },
  details: {
    address: 'Indirizzo',
    subscriptions: 'Abbonamenti correnti',
    best_sales: 'Miglior mese di sempre',
    sales: 'Vendite {{month}}',
    tier: 'Tier {{month}}',
    live_from: 'Data di lancio',
    owner_phone: 'Telefono titolare',
    owner_email: 'Email titolare',
    owner: 'Nome titolare',
    name: 'Ristorante',
    export_csv: 'Esporta CSV',
  },
  publish: 'Pubblica',
  unpublish: 'Annulla pubblicazione',
};
